var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "auth-saas auth-saas--pro", attrs: { id: "wrapper" } },
    [
      _c(
        "div",
        { staticClass: "auth-saas__layout auth-saas__layout--centered" },
        [
          _c("div", { staticClass: "auth-saas__form-column" }, [
            _c("div", { staticClass: "auth-saas__form-inner" }, [
              _c("div", { staticClass: "auth-saas__card" }, [
                _c("p", { staticClass: "auth-saas__eyebrow" }, [
                  _vm._v("Set new password"),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "auth-saas__title" }, [
                  _vm._v(_vm._s(_vm.trans("passwords.reset_password"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "auth-saas__subtitle" }, [
                  _vm._v(
                    "Choose a strong password for your administrator account."
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm.showMessage
                  ? _c(
                      "div",
                      {
                        staticClass: "auth-saas__alert",
                        class: _vm.status
                          ? "auth-saas__alert--success"
                          : "auth-saas__alert--danger",
                        attrs: { role: "alert" },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.message) +
                            "\n                    "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showMessage
                  ? _c(
                      "form",
                      {
                        staticClass: "form-validate is-alter",
                        attrs: { id: "resetform" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.submit.apply(null, arguments)
                          },
                          keydown: function ($event) {
                            return _vm.resetForm.errors.clear(
                              $event.target.name
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "auth-saas__label",
                                attrs: { for: "reset-email" },
                              },
                              [_vm._v("Email")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "auth-saas__input-wrap" },
                              [
                                _c("admin-icon", {
                                  attrs: {
                                    name: "mail",
                                    "aria-hidden": "true",
                                  },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.resetForm.email,
                                      expression: "resetForm.email",
                                    },
                                  ],
                                  staticClass: "auth-saas__input",
                                  attrs: {
                                    id: "reset-email",
                                    type: "text",
                                    name: "email",
                                    autocomplete: "email",
                                    placeholder: _vm.trans("auth.email"),
                                  },
                                  domProps: { value: _vm.resetForm.email },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.resetForm,
                                        "email",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              staticClass: "text-danger",
                              attrs: {
                                "form-name": _vm.resetForm,
                                "prop-name": "email",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "auth-saas__label",
                                attrs: { for: "reset-password" },
                              },
                              [_vm._v(_vm._s(_vm.trans("auth.password")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "auth-saas__input-wrap" },
                              [
                                _c("admin-icon", {
                                  attrs: {
                                    name: "lock",
                                    "aria-hidden": "true",
                                  },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.resetForm.password,
                                      expression: "resetForm.password",
                                    },
                                  ],
                                  staticClass: "auth-saas__input",
                                  attrs: {
                                    id: "reset-password",
                                    type: "password",
                                    name: "password",
                                    autocomplete: "new-password",
                                    placeholder: _vm.trans("auth.password"),
                                  },
                                  domProps: { value: _vm.resetForm.password },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.resetForm,
                                        "password",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              staticClass: "text-danger",
                              attrs: {
                                "form-name": _vm.resetForm,
                                "prop-name": "password",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "auth-saas__label",
                                attrs: { for: "reset-password-confirm" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.trans("auth.confirm_password"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "auth-saas__input-wrap" },
                              [
                                _c("admin-icon", {
                                  attrs: {
                                    name: "lock",
                                    "aria-hidden": "true",
                                  },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.resetForm.password_confirmation,
                                      expression:
                                        "resetForm.password_confirmation",
                                    },
                                  ],
                                  staticClass: "auth-saas__input",
                                  attrs: {
                                    id: "reset-password-confirm",
                                    type: "password",
                                    name: "password_confirmation",
                                    autocomplete: "new-password",
                                    placeholder: _vm.trans(
                                      "auth.confirm_password"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.resetForm.password_confirmation,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.resetForm,
                                        "password_confirmation",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              staticClass: "text-danger",
                              attrs: {
                                "form-name": _vm.resetForm,
                                "prop-name": "password_confirmation",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group mb-0" }, [
                          _c(
                            "button",
                            {
                              staticClass: "auth-saas__btn",
                              attrs: {
                                type: "submit",
                                disabled: _vm.resetForm.busy,
                              },
                            },
                            [
                              _vm.resetForm.busy
                                ? _c("span", {
                                    staticClass: "auth-saas__btn-spinner",
                                    attrs: { "aria-hidden": "true" },
                                  })
                                : _c("admin-icon", {
                                    attrs: {
                                      name: "check",
                                      "aria-hidden": "true",
                                    },
                                  }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.trans("passwords.reset_password"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "auth-saas__note" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.trans("auth.back_to_login?")) +
                        "\n                        "
                    ),
                    _c("router-link", { attrs: { to: "/login" } }, [
                      _vm._v(_vm._s(_vm.trans("auth.sign_in"))),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "auth-saas__footer" },
              [_c("guest-footer")],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-saas__mini-chip" }, [
      _c("span", {
        staticClass: "auth-saas__status-chip-dot",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Password reset")]),
      _vm._v(" "),
      _c("kbd", [_vm._v("Token")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }